<template>
  <div class="modal" v-bind:class="{ 'is-active': isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_HEADER_SEND_MESSAGE_BROADCAST') }}</p>
        <button class="delete" aria-label="close" @click="closeBroadcastViewCancel"></button>
      </header>
      <section class="modal-card-body">
        <div>
          <div v-if="isWhatsapp" class="template">
            <span class="title">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_TEMPLATE') }}:</span>
            <select :class="{ 'input-error': showErrors && !template }" v-model="template" @change="setMessage">
              <option v-for="(template, index) in templates" :key="template.id" :value="index">{{ template.name }}
              </option>
            </select>
          </div>
          <div class="message">
            <span class="title">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_MESSAGE') }}</span>
            <textarea class="textarea" :class="{ 'input-error': showErrors && message.length < 1 }" rows="8" cols="64"
              v-model="message" :disabled="showTemplates && template" @focus="sentencePosition = 0" id="broadcastMessage"
                      v-bind:placeholder="CONSTANTS.getCopy('BROADCASTMESSAGES_MESSAGE_PLACEHOLDER') "></textarea>
          </div>
          <div class="is-flex-row-center buttons" v-if="!isWhatsapp">
            <div class="button" :class="{ 'is-primary': showEmojis }"
              @click="showEmojis = !showEmojis; showAddFile = false">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_BUTTON_EMOJI') }}</div>
            <!--<div class="button" :class="{ 'is-primary': showAddFile }"
              @click="showAddFile = !showAddFile; showEmojis = false">
              <span class="icon">
                <i class="fas fa-file-alt"></i>
              </span>
            </div>-->
          </div>
          <!--<div class="is-flex-row-center file file-route" v-if="isWhatsapp">
            <span>
              Raiz de la URL /
            </span>
            <input type="text" placeholder="escribe aqui la url" id="file-route" v-model="fileRoute" />
          </div>-->
          <!--<div class="broadcast-file">
            <div v-if="showAddFile || isWhatsapp" class="is-flex-row-center file">
              <label for="file">
                <span class="icon"><i class="fas fa-file-alt"></i></span>
                <span v-if="!fileName" class="legend">Seleccione el archivo</span>
                <span v-else class="legend">{{ fileName }}</span>
              </label>
              <input type="file" ref="file" name="resume" id="file" accept="*" @change="setFile" />
            </div>
          </div>-->
          <div class="emojis-container">
            <emojis v-if="showEmojis" @emoji-selected="addElement"></emojis>
          </div>
        </div>
        <div class="bottom-section">
          <div>
            <span class="users-count">🚀 {{ CONSTANTS.getCopy('BROADCASTMESSAGES_BUTTON_MESSAGE_SEND_USERS_1') }}
              {{ usersCount }} {{ CONSTANTS.getCopy('BROADCASTMESSAGES_BUTTON_MESSAGE_SEND_USERS_2') }}</span>
          </div>
          <div class="button is-primary" @click="sendBroadcast">
            <span>{{ CONSTANTS.getCopy('BROADCASTMESSAGES_BUTTON_SEND_BROADCAST') }}</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Answers from '../../lib/AnswersMethods'
import Emojis from '../templates/Emojis'
import '../../css/users-broadcast-messages.css'
import CONSTANTS from '../../constants'

export default {
  components: { Emojis },
  data () {
    return {
      users: null,
      clientName: null,
      client: null,
      platform: null,
      message: '',
      showTemplates: true,
      templates: [],
      template: null,
      templateName: null,
      usersCount: 0,
      limitUsers: 50,
      showErrors: false,
      showEmojis: false,
      fileName: null,
      showAddFile: false,
      sentencePosition: 0,
      boxFocus: 0,
      emojis: [],
      file: null,
      isModalActive: false
    }
  },
  created () {
    Event.$on('showUserBroadcastMessages', (data) => {
      this.reset()
      this.users = data.users
      this.client = data.client
      this.clientName = data.clientName
      this.platform = data.platform
      this.dataReceived()
      this.isModalActive = true
      this.getEmojis()
    })
  },
  computed: {
    isWhatsapp () {
      return this.platform === 'W'
    }
  },
  methods: {
    dataReceived () {
      this.usersCount = this.users.length
      if (this.isWhatsapp) this.getTemplates()
      this.users = this.users.map(function (element) { return element[0] })
    },
    closeBroadcastViewSend () {
      Event.$emit('closeUserBroadcastMessages', true)
      this.isModalActive = false
    },
    closeBroadcastViewCancel () {
      Event.$emit('closeUserBroadcastMessages', false)
      this.isModalActive = false
    },
    getTemplates () {
      this.api.post('/UsersBotGetTemplates', { idClient: this.client }).then((response) => {
        this.templates = response.templates
      })
    },
    setMessage () {
      this.message = this.templates[this.template].message
      this.templateName = this.templates[this.template].name
    },
    callBroadcastService (usersArray) {
      let messageOriginal = this.isWhatsapp ? this.templates[this.template].messageOriginal : this.message
      this.api.post('/UsersBotSendBroadcast',
        { idClient: this.client, platform: this.platform, template: this.templateName, message: messageOriginal, users: usersArray })
    },
    sendBroadcast () {
      if ((this.message.length < 1) || (this.isWhatsapp && !this.template)) {
        this.showErrors = true
        return
      }
      let message = CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_CONFIRM_SEND_BROADCAST')
      this.isModalActive = false
      this.dialog.confirm({ message }).then(() => {
        this.dialog.confirmCountdown().then(() => {
          if (this.usersCount <= this.limitUsers) {
            this.callBroadcastService(this.users)
            this.closeBroadcastViewSend()
            return
          }
          let position = 0
          let tempLimitUsers = this.limitUsers
          while (position < this.usersCount) {
            if (position === 0) {
              this.callBroadcastService(this.users.slice(0, this.limitUsers))
              position = tempLimitUsers
            }
            if ((position + tempLimitUsers) > this.usersCount) tempLimitUsers = this.usersCount - position
            tempLimitUsers < this.limitUsers
              ? this.callBroadcastService(this.users.slice(position))
              : this.callBroadcastService(this.users.slice(position, (position + tempLimitUsers)))
            position = position + tempLimitUsers
          }
        })
      })
      this.closeBroadcastViewSend()
    },
    getEmojis () {
      this.api.post('/DataEmojiList').then(response => {
        this.emojis = response.emojis
        this.emojis.shift()
      })
    },
    addElement (syntax) {
      let data = Answers.addElement(syntax, this.message, this.sentencePosition, `#broadcastMessage`)
      this.message = data.sentence
      this.sentencePosition = data.position
      this.$forceUpdate()
    },
    setFile () {
      let files = this.$refs.file.files

      if (!files.length) {
        this.file = null
        this.fileName = null
        return
      }

      this.file = files[0]
      this.fileName = this.file.name
    },
    reset () {
      this.users = null
      this.clientName = null
      this.client = null
      this.platform = null
      this.message = ''
      this.showTemplates = true
      this.templates = []
      this.template = null
      this.templateName = null
      this.usersCount = 0
      this.limitUsers = 50
      this.showErrors = false
      this.showEmojis = false
      this.fileName = null
      this.showAddFile = false
      this.sentencePosition = 0
      this.boxFocus = 0
      this.emojis = []
      this.file = null
      this.isModalActive = false
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/dialogs/BroadcastMessages.vue